import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import Hammer from '@egjs/hammerjs';
import { Direction } from "./constants";
import { GesturePropError } from "./Errors";
import DraggingGestureHandler from "./DraggingGestureHandler";
import { isnan } from "./utils";

var FlingGestureHandler = function (_DraggingGestureHandl) {
  _inherits(FlingGestureHandler, _DraggingGestureHandl);

  var _super = _createSuper(FlingGestureHandler);

  function FlingGestureHandler() {
    _classCallCheck(this, FlingGestureHandler);

    return _super.apply(this, arguments);
  }

  _createClass(FlingGestureHandler, [{
    key: "onGestureActivated",
    value: function onGestureActivated(event) {
      this.sendEvent(_objectSpread(_objectSpread({}, event), {}, {
        eventType: Hammer.INPUT_MOVE,
        isFinal: false,
        isFirst: true
      }));
      this.isGestureRunning = false;
      this.hasGestureFailed = false;
      this.sendEvent(_objectSpread(_objectSpread({}, event), {}, {
        eventType: Hammer.INPUT_END,
        isFinal: true
      }));
    }
  }, {
    key: "onRawEvent",
    value: function onRawEvent(ev) {
      var _this = this;

      _get(_getPrototypeOf(FlingGestureHandler.prototype), "onRawEvent", this).call(this, ev);

      if (this.hasGestureFailed) {
        return;
      }

      if (ev.isFinal) {
        setTimeout(function () {
          if (_this.isGestureRunning) {
            _this.cancelEvent(ev);
          }
        });
      } else if (!this.hasGestureFailed && !this.isGestureRunning) {
        var gesture = this.hammer.get(this.name);

        if (gesture.options.enable(gesture, ev)) {
          this.onStart(ev);
          this.sendEvent(ev);
        }
      }
    }
  }, {
    key: "getHammerConfig",
    value: function getHammerConfig() {
      return {
        pointers: this.config.numberOfPointers,
        direction: this.getDirection()
      };
    }
  }, {
    key: "getTargetDirections",
    value: function getTargetDirections(direction) {
      var directions = [];

      if (direction & Direction.RIGHT) {
        directions.push(Hammer.DIRECTION_RIGHT);
      }

      if (direction & Direction.LEFT) {
        directions.push(Hammer.DIRECTION_LEFT);
      }

      if (direction & Direction.UP) {
        directions.push(Hammer.DIRECTION_UP);
      }

      if (direction & Direction.DOWN) {
        directions.push(Hammer.DIRECTION_DOWN);
      }

      return directions;
    }
  }, {
    key: "getDirection",
    value: function getDirection() {
      var _this$getConfig = this.getConfig(),
          direction = _this$getConfig.direction;

      var directions = [];

      if (direction & Direction.RIGHT) {
        directions.push(Hammer.DIRECTION_HORIZONTAL);
      }

      if (direction & Direction.LEFT) {
        directions.push(Hammer.DIRECTION_HORIZONTAL);
      }

      if (direction & Direction.UP) {
        directions.push(Hammer.DIRECTION_VERTICAL);
      }

      if (direction & Direction.DOWN) {
        directions.push(Hammer.DIRECTION_VERTICAL);
      }

      directions = _toConsumableArray(new Set(directions));
      if (directions.length === 0) return Hammer.DIRECTION_NONE;
      if (directions.length === 1) return directions[0];
      return Hammer.DIRECTION_ALL;
    }
  }, {
    key: "isGestureEnabledForEvent",
    value: function isGestureEnabledForEvent(_ref, recognizer, _ref2) {
      var minPointers = _ref.minPointers,
          maxPointers = _ref.maxPointers,
          numberOfPointers = _ref.numberOfPointers,
          maxDist = _ref.maxDist,
          maxDeltaX = _ref.maxDeltaX,
          maxDeltaY = _ref.maxDeltaY,
          maxDistSq = _ref.maxDistSq,
          shouldCancelWhenOutside = _ref.shouldCancelWhenOutside;

      var pointerLength = _ref2.maxPointers,
          dx = _ref2.deltaX,
          dy = _ref2.deltaY,
          props = _objectWithoutProperties(_ref2, ["maxPointers", "deltaX", "deltaY"]);

      var validPointerCount = pointerLength === numberOfPointers;

      if (!validPointerCount && this.isGestureRunning) {
        return {
          failed: true
        };
      }

      return {
        success: validPointerCount
      };
    }
  }, {
    key: "updateGestureConfig",
    value: function updateGestureConfig(_ref3) {
      var _ref3$numberOfPointer = _ref3.numberOfPointers,
          numberOfPointers = _ref3$numberOfPointer === void 0 ? 1 : _ref3$numberOfPointer,
          direction = _ref3.direction,
          props = _objectWithoutProperties(_ref3, ["numberOfPointers", "direction"]);

      if (isnan(direction) || typeof direction !== 'number') {
        throw new GesturePropError('direction', direction, 'number');
      }

      return _get(_getPrototypeOf(FlingGestureHandler.prototype), "updateGestureConfig", this).call(this, _objectSpread({
        numberOfPointers: numberOfPointers,
        direction: direction
      }, props));
    }
  }, {
    key: "name",
    get: function get() {
      return 'swipe';
    }
  }, {
    key: "NativeGestureClass",
    get: function get() {
      return Hammer.Swipe;
    }
  }]);

  return FlingGestureHandler;
}(DraggingGestureHandler);

export default FlingGestureHandler;